import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import Error from "../../../../../components/Error/Error";
import { Event } from "../../../../../models/event";
import { addDoc, collection, doc, setDoc } from "firebase/firestore";
import { db } from "../../../../../services/firebase.config";
import { toast } from "react-toastify";

type IDialogAdd = {
    isOpen: boolean,
    onClose: () => void | null,
    reloadDatas: () => Promise<void> | null,

}


const DialogAdd = ({ isOpen, onClose, reloadDatas }: IDialogAdd) => {
    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [speaker, setSpeaker] = useState<string>("");
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs());
    const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
    const [location, setLocation] = useState<string>("");
    const [error, setError] = useState<string | null>(null);

    const resetPopUp = () => {
        setTitle("");
        setDescription("");
        setSpeaker("");
        setStartDate(dayjs());
        setEndDate(dayjs());
        setLocation("");
        setError(null);
    }

    const onValidate = async () => {
        if (title !== "" && location !== "" && startDate !== null && endDate !== null) {
            if (startDate.isAfter(endDate)) {
                return setError("La date de début ne peut pas être supérieur à la date de fin");
            }
            try {
                const event: Event = {
                    id: "",
                    Title: title,
                    Description: description,
                    Speaker: speaker,
                    StartDate: startDate?.toDate() ?? new Date(),
                    EndDate: endDate?.toDate() ?? new Date(),
                    Location: location,
                };
                const idEventAdd = await addDoc(collection(db, "events"), event);
                await setDoc(doc(db, "events", idEventAdd.id), { id: idEventAdd.id }, { merge: true })
                    .then(() => {
                        toast.success("L'évènement a bien été ajoutée", { position: "bottom-center", theme: "colored" });
                    });

                resetPopUp()
                reloadDatas();
                onClose();
            } catch (error: any) {
                setError(error.message);
            }
        } else {
            setError("Veuillez remplir tous les champs obligatoires (Titre, Date de Début, Date de Fin, Localisation)");
        }
    }

    return (
        <Dialog
            open={isOpen}
            onClose={() => onClose()}
        >
            <DialogTitle>
                Ajout d'un évènement
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid size={12} justifyContent={"flex-start"}>
                        <TextField
                            name="title"
                            placeholder="Titre"
                            label="Titre"
                            title="Titre"
                            value={title}
                            fullWidth
                            required
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </Grid>
                    <Grid size={12} justifyContent={"flex-start"}>
                        <TextField
                            name="description"
                            placeholder="Description"
                            label="Description"
                            title="Description"
                            value={description}
                            fullWidth
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Grid>
                    <Grid size={12} justifyContent={"flex-start"}>
                        <TextField
                            name="speaker"
                            placeholder="Conférencier"
                            label="Conférencier"
                            title="Conférencier"
                            value={speaker}
                            fullWidth
                            onChange={(e) => setSpeaker(e.target.value)}
                        />
                    </Grid>
                    <Grid size={12} justifyContent={"flex-start"}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                            <Grid container spacing={8}>
                                <Grid size={6}>
                                    <DateTimePicker
                                        label="Date de Début"
                                        value={startDate}
                                        onChange={(newValue) => setStartDate(newValue)}
                                        views={['year', 'month', 'day', 'hours', 'minutes']} />
                                </Grid>
                                <Grid size={6}>
                                    <DateTimePicker
                                        label="Date de Fin"
                                        value={endDate}
                                        onChange={(newValue) => setEndDate(newValue)}
                                        views={['year', 'month', 'day', 'hours', 'minutes']} />
                                </Grid>
                            </Grid>
                        </LocalizationProvider>
                    </Grid>
                    <Grid size={12} justifyContent={"flex-start"}>
                        <TextField
                            name="Location"
                            placeholder="Localisation"
                            label="Localisation"
                            title="Localisation"
                            value={location}
                            fullWidth
                            required
                            onChange={(e) => setLocation(e.target.value)}
                        />
                    </Grid>
                    <Grid size={12} justifyContent={"flex-start"}>
                        {error && <Error message={error} />}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" aria-label="Annuler l'action" color="error" onClick={() => { resetPopUp(); onClose(); }}>Annuler</Button>
                <Button variant="contained" aria-label="Confirmer l'action" color="success" onClick={() => onValidate()}>Confirmer</Button>
            </DialogActions>
        </Dialog>
    );
}

export default DialogAdd;